import Service from "../Service";

const resource = "accounting/";

const normalizeDataTableAdapter = (response) => {
    const payload = response && response.data ? response.data : null;
    if (!payload) return response;

    if (payload.Data != null && payload.data == null) payload.data = payload.Data;
    if (payload.RecordTotal != null && payload.recordsTotal == null) payload.recordsTotal = payload.RecordTotal;
    if (payload.RecordsTotal != null && payload.recordsTotal == null) payload.recordsTotal = payload.RecordsTotal;
    if (payload.RecordsFiltered != null && payload.recordsFiltered == null) payload.recordsFiltered = payload.RecordsFiltered;

    return response;
};

export default {
    save(obj, requestID) {
        return Service.post(resource + "pysave", obj, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pypagination", parameters, {
            params: { requestID: requestID },
        }).then(normalizeDataTableAdapter);
    },
     getDetailProyect(PcgID, requestID) {
        return Service.get(resource + "getDetailProy", {
            params: { PcgID: PcgID, requestID: requestID },
        });
    },
    pydsave(obj, requestID) {
        return Service.post(resource + "pydsave", obj, {
            params: { requestID: requestID },
        });
    },
};
